const initState = {
  name: 'Select Workspace',
  id: '-1',
  channels: []
};

export default initState;
